import { useState, type FormEvent } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { authEnabled, forgotPassword, translateCognitoError } from '../../auth/auth';
import { sanitizeReturnTo, withReturnTo } from '../../lib/returnTo';

export default function Reset() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  // 認証未設定（モックモード）ではこの画面自体を表示しない。
  if (!authEnabled) return <Navigate to="/" replace />;

  // ログイン画面から引き継いだ復帰先。パスワード再設定完了画面へさらに引き継ぐ。
  const from = sanitizeReturnTo(searchParams.get('from'));

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await forgotPassword(email);
      navigate(withReturnTo(`/reset/confirm?email=${encodeURIComponent(email)}`, from));
    } catch (err) {
      setError(translateCognitoError(err));
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-card__title">パスワードの再設定</h1>
        <p className="auth-card__lead">
          登録済みのメールアドレスを入力すると確認コードを送信します。
        </p>

        <form className="auth-form" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="email">メールアドレス</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {error && <div className="auth-form__error">{error}</div>}

          <button type="submit" className="btn btn--primary" disabled={busy}>
            {busy ? '処理中…' : '確認コードを送信'}
          </button>
        </form>

        <div className="auth-form__links">
          <Link to={withReturnTo('/login', from)}>ログイン画面へ戻る</Link>
        </div>
      </div>
    </div>
  );
}
